export enum Features {
    AllCustomersProjects = 'allCustomersProjects',
    AuthAddFeatureToRoleSave = 'authAddFeatureToRoleSave',
    AuthFeatures = 'authFeatures',
    AuthLoginAsUserSave = 'authLoginAsUserSave',
    AuthorisationLogPostCalls = 'authorisationLogPostCalls',
    AuthRemoveFeatureFromRoleSave = 'authRemoveFeatureFromRoleSave',
    AuthRoles = 'authRoles',
    Customers = 'customers',
    Drawings = 'drawings',
    DrawingsByTtm_ttmId_ = 'drawingsByTtm_ttmId_',
    DrawingsConvertDetailSave = 'drawingsConvertDetailSave',
    DrawingsDetail = 'drawingsDetail',
    DrawingsDrawingMapsSave = 'drawingsDrawingMapsSave',
    DrawingsEntities = 'drawingsEntities',
    DrawingsEntitiesSave = 'drawingsEntitiesSave',
    DrawingsExtractDetailSave = 'drawingsExtractDetailSave',
    DrawingsFilters = 'drawingsFilters',
    DrawingsGenerateSvgsDetailSave = 'drawingsGenerateSvgsDetailSave',
    DrawingsPaginated = 'drawingsPaginated',
    DrawingsSave = 'drawingsSave',
    DrawingsTtmsSave = 'drawingsTtmsSave',
    DrawingsUploadSave = 'drawingsUploadSave',
    EntitiesDetail = 'entitiesDetail',
    EntitiesForTtm_ttmId_ = 'entitiesForTtm_ttmId_',
    EntitiesMultiSave = 'entitiesMultiSave',
    EntitiesSave = 'entitiesSave',
    ExportInterface = 'exportInterface',
    ExportInterfaceDetailSiblings = 'exportInterfaceDetailSiblings',
    GeoserverLayers = 'geoserverLayers',
    GeoserverTiles_workspace__layer__z__x__y_ = 'geoserverTiles_workspace__layer__z__x__y_',
    Projects = 'projects',
    ProjectsAccessAny = 'projectsAccessAny',
    ProjectsDetail = 'projectsDetail',
    ProjectsDetailImages = 'projectsDetailImages',
    ShowSensetiveInformation = 'showSensetiveInformation',
    TtmImages_ttmId_ = 'ttmImages_ttmId_',
    TtmImages_ttmImageId_Delete = 'ttmImages_ttmImageId_Delete',
    TtmImagesDownload_imageId_ = 'ttmImagesDownload_imageId_',
    TtmImagesImage_imageId_ = 'ttmImagesImage_imageId_',
    TtmImagesLatest = 'ttmImagesLatest',
    TtmImagesLatestSave = 'ttmImagesLatestSave',
    TtmImagesUploadSave = 'ttmImagesUploadSave',
    Ttms = 'ttms',
    TtmsAddSave = 'ttmsAddSave',
    TtmsDetailDelete = 'ttmsDetailDelete',
    TtmsFindReplacementTtmDetail = 'ttmsFindReplacementTtmDetail',
    TtmsHistoryDetail = 'ttmsHistoryDetail',
    TtmsImages = 'ttmsImages',
    TtmsMergeSave = 'ttmsMergeSave',
    TtmsRegenerateImage_ttmId_ = 'ttmsRegenerateImage_ttmId_',
    TtmsSplitSave = 'ttmsSplitSave',
    TtmsStatuses = 'ttmsStatuses',
    TtmsTypes = 'ttmsTypes',
    TtmsUpdateAmountSave = 'ttmsUpdateAmountSave',
    TtmsUpdateCommentSave = 'ttmsUpdateCommentSave',
    TtmsUpdateStatusSave = 'ttmsUpdateStatusSave',
    TtmsUpdateWeightingSave = 'ttmsUpdateWeightingSave',
    TtmTicketDetail = 'ttmTicketDetail',
    TtmTickets_ticketId_Comments_commentId_Delete = 'ttmTickets_ticketId_Comments_commentId_Delete',
    TtmTicketsAssigneesList = 'ttmTicketsAssigneesList',
    TtmTicketsDetail = 'ttmTicketsDetail',
    TtmTicketsDetailCommentsSave = 'ttmTicketsDetailCommentsSave',
    TtmTicketsDetailDelete = 'ttmTicketsDetailDelete',
    TtmTicketsDetailMuteSave = 'ttmTicketsDetailMuteSave',
    TtmTicketsDetailUnmuteSave = 'ttmTicketsDetailUnmuteSave',
    TtmTicketsDetailUpdate = 'ttmTicketsDetailUpdate',
    TtmTicketsListPaginated = 'ttmTicketsListPaginated',
    TtmTicketsPaginated = 'ttmTicketsPaginated',
    TtmTicketsSave = 'ttmTicketsSave',
    TtmTicketsStatus_status_ = 'ttmTicketsStatus_status_',
    TtmTicketsStatusesList = 'ttmTicketsStatusesList',
    TtmTicketsUsersList = 'ttmTicketsUsersList',
    Users = 'users',
    UsersDetail = 'usersDetail',
    UsersDetailDelete = 'usersDetailDelete',
    UsersManagers = 'usersManagers',
    UsersPaginated = 'usersPaginated',
    UsersSave = 'usersSave',
    UsersToggleTicketNotificationsSave = 'usersToggleTicketNotificationsSave',
    WorkorderImages = 'workorderImages',
    Workorders = 'workorders',
    WorkordersAccessAny = 'workordersAccessAny',
    WorkordersDetail = 'workordersDetail',
    WorkordersDrawingFileDetail = 'workordersDrawingFileDetail',
    WorkordersImportAttachmentsSave = 'workordersImportAttachmentsSave',
    WorkordersPlanned = 'workordersPlanned',
    WorkordersShowIncomplete = 'workordersShowIncomplete',
    WorkordersTtmsSave = 'workordersTtmsSave',
}
